import Vue from "vue";
import Vuex from "vuex";
import * as user from "@/store/modules/user.js";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    user
  },
  state: {
    activeTheme: "",
    darkThemes: ["superhero", "slate", "darkly"],
    libraryQuery: null
  },
  mutations: {
    setLibraryQuery(state, value) {
      console.log("mutation setLibraryQuery called");
      //se passo valore null
      state.libraryQuery = value;
      //altrimenti salva dati
      if (value) {
        state.libraryQuery = {};
        state.libraryQuery.page = value.page;
        state.libraryQuery.pageSize = value.pageSize;
        state.libraryQuery.orderBy = value.orderBy;
        state.libraryQuery.dir = value.dir;
        //filtro search
        state.libraryQuery.searchField = value.searchField;
        state.libraryQuery.searchText = value.searchText;
      }
    },
    setActiveTheme(state, value) {
      state.activeTheme = value;
    }
  },
  actions: {},
  getters: {
    isDarkTheme: state => {
      console.log(
        "isdarktheme: " + state.darkThemes.indexOf(state.activeTheme) > -1
      );
      return state.darkThemes.indexOf(state.activeTheme) > -1;
    }
  }
});
